export const contact = {
  weekdays: 'Weekdays 9am-5pm AET',
  email: 'hello@athena.com.au',
  phone: '13 35 35',
  SMS: '0429 333 555',
};
